module.exports = __webpack_public_path__ + "img/wave_top_page.ff85d333.png";